
export const allNumbers = [
    {text: "7", id:"seven"}, 
    {text: "8", id: "eight"}, 
    {text: "9", id: "nine"},
    {text: "4", id: "four"}, 
    {text: "5", id: "five"}, 
    {text: "6", id: "six"},
    {text: "1", id: "one"}, 
    {text: "2", id: "two"}, 
    {text: "3", id: "three"},
    {text: "+/-", id: "pos-neg"}, 
    {text: "0", id: "zero"}, 
    {text: ".", id: "decimal"}
];